import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwapVerticalCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swap_vertical_circle"}/>
}
